const styles = {
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5vh 0',
  },
  emptyCartImage: {
    width: '100%',
    maxWidth: '278px',
    height: 'auto',
  },
};

export default styles;
